module.exports = __webpack_public_path__ + "img/facebook.918c4111.svg";